import React from 'react'

const ProgramList = ({ list, channelKey }) => {

  return (
    <>{
      list.map((program, i) => {
        return (
          <div key={`program-${channelKey}-${i}`} className={`col-prog ${channelKey === 0 && 'pt-0'}`} style={program.styles}>
            <div className={`block-prog ${program.openFromAt}`}>
              <p>{program.description}</p>
              <p className="txt-programs">{program.genre}</p>
              <p className="txt-hours">{program.from} - {program.at}</p>
            </div>
          </div>
        )
      })
    }</>
  )  
}

export default React.memo(ProgramList)
